import {styled} from "@mui/material/styles"
import {breakpoints, FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const Container = styled("a")`
    display: flex;
    flex-direction: column;
    text-align: center;
    flex-grow: 1;
    margin-right: 1rem;
    cursor: pointer;
    text-decoration: none;
    height: 100%;

    :hover {
        span {
            text-decoration: underline;
        }
    }

    :last-child {
        margin-right: 0;
    }
`
export const ImageTitle = styled("span")`
    color: ${({theme}) => theme.uxfabric.components.menu.megaMenu.mission.textColor};
    font-size: ${({theme}) => theme.uxfabric.global.body2.fontSize} !important;
    font-family: ${({theme}) => theme.uxfabric.global.body2.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
    text-decoration: none;
    word-break: break-word;
    hyphens: auto;
`

export const ImageWrapper = styled("div")`
    width: 100%;
    position: relative;
    margin-bottom: 0.5rem;
    overflow: hidden;
`

export const ImageContainer = styled("img")`
    width: 100%;
    height: auto;
    background: ${({theme}) => theme.uxfabric.components.menu.megaMenu.mission.backgroundColor};
    /**
        Constrain the images as a safeguard from CMS
        supplying abnormal sizes
     */
    max-width: 25rem; // 400px
    max-height: 37.5rem; // 600px
    @media (min-width: ${breakpoints.values.lg - 1}px) {
        max-width: 12.5rem; // 200px
        max-height: 18.75rem; // 300x
    }
`
